
import { Component, OnInit, Input, OnChanges, SimpleChanges, NgZone, ViewChild } from '@angular/core';
import { GoogleChartService } from '../services/google-chart.service';
import { Router, ActivatedRoute, RouterEvent, NavigationEnd } from '@angular/router';
import { ConsumptionHist } from '../Models/MeterModel';
import { DatePipe } from '@angular/common';
import { MinMaxDate } from '../Models/MiscModels';
import { MeterService } from '../services/meter.service';
import { SignalrISOdataService } from '../services/signalr-ISOdata.service';
import { MiscService } from '../services/misc.service';
import { NONE_TYPE } from '@angular/compiler/src/output/output_ast';
import { ResizedEvent } from 'angular-resize-event';
import { filter, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';


@Component({
  selector: 'app-monthly-dist',
  templateUrl: './monthly-dist.component.html',
  styleUrls: ['./monthly-dist.component.css']
})
export class MonthlyDistComponent implements OnInit {

  public destroyed = new Subject<any>();

  private minMaxDate: MinMaxDate;
  private MonthlyHistTable: any;
  private MonthlyHistDashboard: any;
  private chartTitle: string;

  private MonthlyHistDateSlider: any;
  private width: number;
  private height: number;
  private controlOptions: any;


  constructor(private gChartService: GoogleChartService, private route: ActivatedRoute, private ngZone: NgZone) {

  }


  private chartDataMonthly = new Array<ConsumptionHist>();


  private options = {
    enableInteractivity: true,

    seriesType: 'scatter',
    series: {
      0: { color: 'grey' },
      1: { color: 'red' },
      2: { color: '#13f9f6' },
    },
    orientation: 'vertical',
    legend: {
      position: 'top', alignment: 'end'
    },

    pointsVisible: true,
    titleTextStyle: {
      color: 'black',    // any HTML string color ('red', '#cc00cc')
      fontName: 'Montesserat', // i.e. 'Times New Roman'
      fontSize: '24', // 12, 18 whatever you want (don't specify px)
      bold: false,    // true or false
      italic: true,   // true of false
    },
    chartArea: { width: '80%', height: '80%' },
    crosshair: { trigger: 'both' },
    curveType: 'function',
    lineWidth: 2,

    //vAxis: { title: 'KW', textStyle: { fontSize: '12' }, format: '#,### KW', textPosition:'out' },
    vAxis: {
      title: 'PJM Load',
      textStyle: {
        color: '#1a237e',
        fontSize: 14,

      },
      format: '#,### KW',
      titleTextStyle: {
        color: '#1a237e',
        fontSize: 18,
        bold: false,
      }
    },

    hAxis: {
      title: 'Percentile',
      textStyle: {
        fontSize: '14'
      },
      format: 'percent',
      gridlines: {
        count: -1,

      },
      minorGridlines: {

      },
      maxValue: 1,
      minValue: 0,
    },

  }
  setFilterOptions() {
    this.controlOptions = {

      'filterColumnIndex': 1,
      ui: {
        'chartOptions': {
          vAxis: { textStyle: { fontSize: '12' }, format: '#,### KW', textPosition: 'out' },
          orientation: 'vertical',
          chartArea: { width: '80%', height: '90%' },
          hAxis: {
            format: 'percent',
            textStyle: {
              fontSize: '12'
            },
            gridlines: {
              count: -1,

            },
            minorGridlines: {

            },


          }
        },
      }

    }
  }

  ngOnInit() {
    var google = this.gChartService.getGoogle();
    google.charts.load('current', { 'packages': ['corechart', 'table', 'controls'] });
    google.charts.setOnLoadCallback(this.drawMonthlyHistChart.bind(this));
    this.route.params.pipe(
      takeUntil(this.destroyed)
    ).subscribe(val => {
      this.chartDataMonthly = this.route.snapshot.data.monthlyDistData;
    });



  }
  formatAxes(MonthlyHistTable) {
    var google = this.gChartService.getGoogle();
    const formatterKW = new google.visualization.NumberFormat({ suffix: ' KW', pattern: '#,###' });
    formatterKW.format(MonthlyHistTable, 0); // Apply formatter to second column

    const formatterPercent = new google.visualization.NumberFormat({ pattern: 'percent' });
    formatterPercent.format(MonthlyHistTable, 1); // Apply formatter to second column
    formatterPercent.format(MonthlyHistTable, 2); // Apply formatter to second column
    formatterPercent.format(MonthlyHistTable, 3); // Apply formatter to second column
  }

  private drawMonthlyHistChart(options) {
    var google = this.gChartService.getGoogle();
    // Create the dataset (DataTable)
    // Create the dataset (DataTable)
    this.MonthlyHistTable = new google.visualization.DataTable();
    this.MonthlyHistTable.addColumn('number', 'Percentile');
    this.MonthlyHistTable.addColumn('number', 'Jan');
    this.MonthlyHistTable.addColumn('number', 'Feb');
    this.MonthlyHistTable.addColumn('number', 'March');
    this.MonthlyHistTable.addColumn('number', 'April');
    this.MonthlyHistTable.addColumn('number', 'May');
    this.MonthlyHistTable.addColumn('number', 'June');
    this.MonthlyHistTable.addColumn('number', 'July');
    this.MonthlyHistTable.addColumn('number', 'August');

    this.MonthlyHistTable.addColumn('number', 'Sep');
    this.MonthlyHistTable.addColumn('number', 'Oct');
    this.MonthlyHistTable.addColumn('number', 'Nov');
    this.MonthlyHistTable.addColumn('number', 'Dec');

    let nSeries: number;
    var series = {};
    for (let i = 0; i < 38; i++) {
      let chartRow = new Array<number>();

      if (this.chartDataMonthly[i].kw == 0)
        this.chartDataMonthly[i].kw = null;

      chartRow.push(this.chartDataMonthly[i].kw);
      nSeries = 0;
      chartRow.push(this.chartDataMonthly[i + nSeries].percentile);

      nSeries = nSeries + 38;
      chartRow.push(this.chartDataMonthly[i + nSeries].percentile);

      nSeries = nSeries + 38;
      chartRow.push(this.chartDataMonthly[i + nSeries].percentile);

      nSeries = nSeries + 38;
      chartRow.push(this.chartDataMonthly[i + nSeries].percentile);

      nSeries = nSeries + 38;
      chartRow.push(this.chartDataMonthly[i + nSeries].percentile);

      nSeries = nSeries + 38;
      chartRow.push(this.chartDataMonthly[i + nSeries].percentile);

      nSeries = nSeries + 38;
      chartRow.push(this.chartDataMonthly[i + nSeries].percentile);

      nSeries = nSeries + 38;
      chartRow.push(this.chartDataMonthly[i + nSeries].percentile);

      nSeries = nSeries + 38;
      chartRow.push(this.chartDataMonthly[i + nSeries].percentile);

      nSeries = nSeries + 38;
      chartRow.push(this.chartDataMonthly[i + nSeries].percentile);

      nSeries = nSeries + 38;
      chartRow.push(this.chartDataMonthly[i + nSeries].percentile);

      nSeries = nSeries + 38;
      chartRow.push(this.chartDataMonthly[i + nSeries].percentile);

      if (i > 0) {
        series[i - 1] = {};
      }
      this.MonthlyHistTable.addRow(chartRow);
    }
    this.chartTitle = 'Monthly Load Curve: Rate of Electricity Use (KW) versus Cumulative Perecentile';



    // Create a dashboard.
    const dash_container = document.getElementById('MonthlyHistdashboard_div');

    this.MonthlyHistDashboard = new google.visualization.Dashboard(dash_container);

    // Create a date range slider
    this.MonthlyHistDateSlider = new google.visualization.ControlWrapper({
      'controlType': 'ChartRangeFilter',
      'containerId': 'MonthlyHistcontrol_div',
      'state': { 'range': { 'start': 0, 'end': 38 } }
    });
    this.setFilterOptions();
    this.MonthlyHistDateSlider.setOptions(this.controlOptions);

    this.formatAxes(this.MonthlyHistTable);

    // Line chart visualization
    var MonthlyHistLine = new google.visualization.ChartWrapper({
      'chartType': 'ComboChart',
      'containerId': 'MonthlyHistline_div',

      'options': this.options,
    });

    MonthlyHistLine.setOption('title', this.chartTitle);
    // Bind MonthlyHistLine to the dashboard, and to the controls
    // this will make sure our line chart is updated when our date changes
    this.MonthlyHistDashboard.bind(this.MonthlyHistDateSlider, MonthlyHistLine);

    this.MonthlyHistDashboard.draw(this.MonthlyHistTable);
    var columns = [];
    var series = {};
    for (var i = 0; i < this.MonthlyHistTable.getNumberOfColumns(); i++) {
      columns.push(i);
      if (i > 0) {
        series[i - 1] = {};
      }
    }
  }

  onResized(event: ResizedEvent) {
    this.width = event.newWidth;
    this.height = event.newHeight;


    console.log('width', this.width);
    console.log('height', this.height);

    if (this.MonthlyHistDashboard != undefined) {
      this.MonthlyHistDashboard.draw();
      this.MonthlyHistDateSlider.draw();
    }
  }
  ngOnDestroy(): void {
    this.destroyed.next();
    this.destroyed.complete();
  }
}

